import { render, staticRenderFns } from "./answerDetails.vue?vue&type=template&id=4790da2b&scoped=true&"
import script from "./answerDetails.vue?vue&type=script&lang=js&"
export * from "./answerDetails.vue?vue&type=script&lang=js&"
import style0 from "./answerDetails.vue?vue&type=style&index=0&id=4790da2b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4790da2b",
  null
  
)

export default component.exports